import { Trash2 } from 'lucide-react';

import type { RowActionItem } from '@/components/ui/row-actions-menu';
import type { ChatSession } from '@/services/api';

/** The row menu items for a chat. "Delete chat" appears only when the server allows it. */
export function chatRowActionItems(
  session: Pick<ChatSession, 'canDelete'>,
  onRequestDelete: () => void,
): RowActionItem[] {
  if (!session.canDelete) return [];
  return [{ label: 'Delete chat', icon: Trash2, danger: true, onClick: onRequestDelete }];
}

export type ChatDeleteState =
  | { phase: 'idle'; error: string | null }
  | { phase: 'confirming'; sessionId: string; sessionName: string; error: string | null }
  | { phase: 'deleting'; sessionId: string; sessionName: string; error: string | null };

export type ChatDeleteEvent =
  | { type: 'request'; sessionId: string; sessionName: string }
  | { type: 'cancel' }
  | { type: 'confirm' }
  | { type: 'succeeded' }
  | { type: 'failed'; error: string }
  | { type: 'dismissError' };

export const INITIAL_CHAT_DELETE_STATE: ChatDeleteState = { phase: 'idle', error: null };

/** One confirmation per delete: request opens the dialog, confirm deletes, the result closes it. */
export function chatDeleteReducer(state: ChatDeleteState, event: ChatDeleteEvent): ChatDeleteState {
  switch (event.type) {
    case 'request':
      if (state.phase === 'deleting') return state;
      return { phase: 'confirming', sessionId: event.sessionId, sessionName: event.sessionName, error: null };
    case 'cancel':
      return state.phase === 'confirming' ? { phase: 'idle', error: state.error } : state;
    case 'confirm':
      return state.phase === 'confirming' ? { ...state, phase: 'deleting' } : state;
    case 'succeeded':
      return state.phase === 'deleting' ? { phase: 'idle', error: null } : state;
    case 'failed':
      return state.phase === 'deleting' ? { phase: 'idle', error: event.error } : state;
    case 'dismissError':
      return { ...state, error: null };
  }
}

export function chatDeleteConfirmationMessage(sessionName: string): string {
  return `Delete "${sessionName}"? Its messages are removed. This cannot be undone.`;
}
